import { Box, Container, Paper, useMediaQuery } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MasterLogo from "assets/images/master_footer_inverted.png";
import FACLogo from "assets/images/fac.png";
import VisaLogo from "assets/images/visa.png";
import { getToken } from "middleware/storage";
import Loading from "components/shared/loader/loader";
import IconHeader from "components/public-dashboard/components/iconHeader";
import TopupStepper from "./stepper";
import { fetchAddressCountries, setActiveStep } from "./topupSlice";
import SystemMessage from "components/public-dashboard/components/systemMessage";
import useServiceStatus from "hooks/useServiceStatus";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight:'100vh'
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      boxShadow: "none",
      margin: theme.spacing(1),
    },
  },
  logo: {
    height: 55,
    [theme.breakpoints.down("sm")]: {
      height: 50,
      width: "auto",
    },
  },
  gridContainer: {
    [theme.breakpoints.up("sm")]: {
    },
  },
}));

export default function Topup(props) {
  useDocumentTitle(
    "Quick Top Up | YOOZ",
    "Top Up in seconds on our FREE and EASY TO USE, SECURE platform. Top Up your phone or someone else's with your Credit or Debit Card, anytime, anywhere."
  );

  const classes = useStyles();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down("md"));
  const token = getToken();
  const { loading } = useSelector((state) => state.topup);
  const dispatch = useDispatch();

  useEffect(async () => {
    dispatch(setActiveStep(0));
    await dispatch(fetchAddressCountries());
  }, [dispatch]);

  const { serviceLoading, serviceStatus } = useServiceStatus("topup");
  if (serviceLoading) {
    return <Loading />;
  }

  return (
    <Box className={classes.root}>
      {loading === "pending" && <Loading />}
      <Container maxWidth="lg">
        {!token ? (
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            spacing={1}
            className={classes.gridContainer}
          >
            <Grid item>
              <IconHeader
                title="Quick Top Up"
                iconColor={theme.palette.primary.main}
                titleColor={theme.palette.secondary.main}
                titleLg="h2"
              />
            </Grid>
          </Grid>
        ) : (
          <IconHeader
            title="Top Up"
            iconColor={theme.palette.primary.main}
            titleColor={theme.palette.secondary.main}
            titleLg="h2"
          />
        )}
        <Paper className={classes.paper}>
          <Grid
            container
            spacing={1}
            alignItems="center"
            direction="row"
            justify="center"
          >
            <Grid item xs={12}>
              {serviceStatus.isActive ? <TopupStepper />: <SystemMessage title={serviceStatus.statusTitle} message={serviceStatus.statusMessage} type={serviceStatus.messageType}/>}
            </Grid>
            {token && (
              <Grid item xs={12}>
                <Grid
                  item
                  container
                  spacing={2}
                  alignItems="center"
                  direction="row"
                  justify="center"
                >

                  <Grid item xs={12} sm={12} md={4}
                        container
                        justify="center">
                    <img
                        src={MasterLogo}
                        alt="Mastercard SecureCode"
                        className={classes.logo}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}  md={4}
                        container
                        justify="center">
                    <img
                        src={VisaLogo}
                        alt="Verified by Visa"
                        className={classes.logo}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}  md={4}
                        container
                        justify="center">
                    <img
                        src={FACLogo}
                        alt="Powered By Powertrans"
                        className={classes.logo}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}
